import { IconProps } from './IconProps';

export const AppleLogo = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1961 0.321632C10.1961 1.14091 9.84479 1.96019 9.34819 2.55066C8.82121 3.20512 7.90939 3.69157 7.18443 3.69157C7.1014 3.69157 7.01837 3.68037 6.96728 3.67077C6.95766 3.63076 6.93691 3.50595 6.93691 3.38114C6.93691 2.55066 7.3617 1.73137 7.81679 1.21292C8.39646 0.539252 9.35777 0.030403 10.1658 0C10.1865 0.0928091 10.1961 0.208021 10.1961 0.321632ZM13.045 5.4819C13.0648 5.46885 13.0785 5.4599 13.0848 5.45496C12.0086 3.90919 10.3734 3.86758 9.91824 3.86758C9.22202 3.86758 8.5988 4.11503 8.07503 4.32298C7.69542 4.4737 7.36805 4.60368 7.103 4.60368C6.81004 4.60368 6.47463 4.46795 6.10037 4.3165C5.62803 4.12537 5.09381 3.90919 4.50491 3.90919C2.51842 3.90919 0.5 5.55896 0.5 8.66967C0.5 10.6091 1.24573 12.6525 2.16871 13.9678C2.96555 15.0879 3.65858 16 4.65182 16C5.12277 16 5.46807 15.8532 5.83122 15.6988C6.23396 15.5276 6.65864 15.3471 7.30099 15.3471C7.95026 15.3471 8.33821 15.5167 8.71224 15.6802C9.06035 15.8323 9.39641 15.9792 9.91984 15.9792C11.0057 15.9792 11.7195 14.9951 12.403 14.0094C13.1695 12.8893 13.4904 11.79 13.5 11.7388C13.4377 11.718 11.357 10.8779 11.357 8.50327C11.357 6.59114 12.7755 5.659 13.045 5.4819Z"
        fill={props.fill ?? '#000000'}
      />
    </svg>
  );
};

